import { SelectOptionsRouteEvent } from '../models/select-options-route-event.model';

export enum RouteEventEnum {
  DVIRS_IN_PROGRESS = 0,
  DVIRS_SAFE = 1,
  DVIRS_NOT_SAFE = 2,
  DRIVING_THROUGH_RED = 3,
  DRIVING_WITH_UNLATCHED_BELT = 4,
  DRIVING_WITH_PHONE_IN_HAND = 5,
  ILLEGAL_PARKING = 6,
  NO_STOPPING_IN_FRONT_STOP_SIGN = 7,
  CROSS_DOUBLE_UNBROKEN = 8,
  SPENDING = 9,
  IMPOSING_EMERGENCY = 10,
  EMERGENCY_BREAKING = 12,
  INAPPROPRIATE_MODE = 13,
  FAILING_ASLEEP_FAINTING = 14,
  SOS = 15,
  BREAK = 16,
  SHIPER_RECEIVER = 17,
  FUELING = 18,
  YM_MODE = 19,
  DRIVE_MODE = 20,
  PC_MODE = 21,
}

export const RouteEvent: SelectOptionsRouteEvent[] = [
  { value: RouteEventEnum.DVIRS_IN_PROGRESS, label: 'DVIR In progress', color: '#0D99FF' },
  { value: RouteEventEnum.DVIRS_SAFE, label: 'DVIR Safe', color: '#AFF4C6' },
  { value: RouteEventEnum.DVIRS_NOT_SAFE, label: 'DVIR Not safe', color: '#E4CCFF' },
  { value: RouteEventEnum.DRIVING_THROUGH_RED, label: 'Driving through a red', color: '#F24822' },
  { value: RouteEventEnum.DRIVING_WITH_UNLATCHED_BELT, label: 'Driving with unlatched belt', color: '#F24822' },
  { value: RouteEventEnum.DRIVING_WITH_PHONE_IN_HAND, label: 'Driving with phone in hand', color: '#F24822' },
  { value: RouteEventEnum.ILLEGAL_PARKING, label: 'Illegal parking', color: '#F24822' },
  {
    value: RouteEventEnum.NO_STOPPING_IN_FRONT_STOP_SIGN,
    label: 'No stopping in front of the "Stop" sign',
    color: '#F24822',
  },
  { value: RouteEventEnum.CROSS_DOUBLE_UNBROKEN, label: 'Cross double unbroken', color: '#F24822' },
  { value: RouteEventEnum.SPENDING, label: 'Speeding (below 10 & below 30 m/h)', color: '#F24822' },
  { value: RouteEventEnum.IMPOSING_EMERGENCY, label: 'Imposing emergency', color: '#FFCD29' },
  { value: RouteEventEnum.EMERGENCY_BREAKING, label: 'Emergency breaking', color: '#FFCD29' },
  { value: RouteEventEnum.INAPPROPRIATE_MODE, label: 'Inappropriate mode', color: '#FFCD29' },
  { value: RouteEventEnum.FAILING_ASLEEP_FAINTING, label: 'Falling asleep/fainting while driving', color: '#1E1E1E' },
  { value: RouteEventEnum.SOS, label: 'SOS', color: '#1E1E1E' },
  { value: RouteEventEnum.BREAK, label: 'Break (including Regular Break, SB (LSB, SSB)', color: '#0D99FF' },
  {
    value: RouteEventEnum.SHIPER_RECEIVER,
    label: 'Shipper/Receiver',
    color: '#0D99FF',
    iconName: 'file_download',
    class: 'material-symbols-outlined',
  },
  {
    value: RouteEventEnum.FUELING,
    label: 'Fueling',
    color: '#0D99FF',
    iconName: 'local_gas_station',
    class: 'material-icons',
  },
  { value: RouteEventEnum.YM_MODE, label: 'YM mode', color: '#0D99FF' },
  { value: RouteEventEnum.DRIVE_MODE, label: 'Drive mode', color: '#14AE5C' },
  { value: RouteEventEnum.PC_MODE, label: 'PC mode', color: '#9747FF' },
];
